__webpack_require__.p = "/react-star-match/";